// Timezone
// ----------------------------------------------------------------
// Uses momentjs: https://momentjs.com/timezone/docs/
// must be loaded on the page prior to running this
var MGS = MGS || {};

MGS.timezones = {
  init : function() {
    MGS.timezones.setupTimeZoneSelect();

    this.defaultTimezone = 'US/Pacific';
    moment.tz.setDefault(MGS.timezones.defaultTimezone);

    // If already timezone set, use that or default to default
    var tz = ($.cookie('selectedTimezone')) ? $.cookie('selectedTimezone') : MGS.timezones.defaultTimezone;
    MGS.timezones.updateTimeZone(tz);
  },

  setupTimeZoneSelect : function() {
    var $tzSelect = $('.select-timezone');

    // If timezone already set, select that option, otherwise set to default
    var tz = ($.cookie('selectedTimezone')) ? $.cookie('selectedTimezone') : MGS.timezones.defaultTimezone;
    $tzSelect.each(function() {
      $(this).val(tz).trigger('change');
    });

    $tzSelect.on('change',function() {
      var tz = $(this).val();

      // Set cookie to remember timezone
      $.cookie('selectedTimezone', tz, { expires: 1200, path: '/'});

      // Update times on page
      MGS.timezones.updateTimeZone(tz);
    });
  },

  updateTimeZone : function(newTZ) {
    $('.tz-adjust').each(function() {
      var initialTime = moment.tz($(this).attr('datetime'), MGS.timezones.defaultTimezone);

      var outputZone = newTZ,
          outputTime = initialTime.tz(outputZone).format('h:mma');

      $(this).text(outputTime);
    });
    $('.tz-name').each(function() {
      var zoneAbbr = moment.tz(newTZ).zoneAbbr();
      $(this).text(zoneAbbr);
    });
  }
}

// Initialize timezones
$(function() {
  MGS.timezones.init();
})